import type { Card, AnswerResult } from '../types'

/**
 * RuleEngine - 规则判定引擎
 * 负责判断答案正确性、获取规则引用和知识来源
 */
export class RuleEngine {
  /**
   * 判定答案是否正确
   */
  evaluate(card: Card, choiceIndex: number): AnswerResult {
    const choice = card.choices[choiceIndex]
    if (!choice) {
      throw new Error(`Invalid choice index: ${choiceIndex} for card: ${card.id}`)
    }

    const correctChoice = card.choices.find(c => c.isCorrect)
    if (!correctChoice) {
      console.warn(`Card ${card.id} has no correct answer defined`)
    }

    return {
      isCorrect: choice.isCorrect,
      feedback: choice.feedback,
      correctAnswer: correctChoice?.text ?? '无正确答案',
      explanation: card.back.explanation,
      ruleRef: card.back.ruleRef,
      sourceRef: card.back.sourceRef,
      sourceUrl: card.back.sourceUrl,
    }
  }

  /**
   * 获取卡片关联的知识点
   */
  getRelatedConcepts(card: Card): string[] {
    return card.back.ruleRef
  }

  /**
   * 获取知识来源
   */
  getSourceReference(card: Card): string {
    return card.back.sourceRef
  }
}
